import { render, staticRenderFns } from "./mod6.vue?vue&type=template&id=6c71c9b7&scoped=true&"
import script from "./mod6.vue?vue&type=script&lang=js&"
export * from "./mod6.vue?vue&type=script&lang=js&"
import style0 from "./mod6.vue?vue&type=style&index=0&id=6c71c9b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71c9b7",
  null
  
)

export default component.exports